import { breakpoints } from "Utilities"

export const WINDOW_SIZE_CHANGED = "WINDOW_SIZE_CHANGED"

//Action
export function handleChangedSize() {
  return (dispatch) => {  
    const mqlMobile = window.matchMedia(`(max-width: ${breakpoints.mobileMax}px) and (pointer:coarse)`)
    const mqlTabletPortrait = window.matchMedia(`(max-width: ${breakpoints.tabletMaxPortrait}px) and (min-width: ${breakpoints.tabletMinPortrait}px) and (pointer:coarse)`)
    const mqlTabletLandscape = window.matchMedia(`(max-width: ${breakpoints.tabletMaxLandscape}px) and (min-width: ${breakpoints.tabletMinLandscape}px) and (pointer:coarse)`)
    
    dispatch({
      type: WINDOW_SIZE_CHANGED,
      data:{
        mqlMobile,
        mqlTabletLandscape,
        mqlTabletPortrait
      }
      
    });
  }
}


//Reducer
export function reducer(state, action){
  if(action.type === WINDOW_SIZE_CHANGED){
    const isMobile = action.data.mqlMobile.matches
    const isTabletLandscape = action.data.mqlTabletLandscape.matches
    const isTabletPortrait = action.data.mqlTabletPortrait.matches
    return {
      ...state,
      isMobile,
      isTabletLandscape,
      isTabletPortrait
    }
  }else{
    return state
  }
}